import { combineReducers } from "redux";
import { localeReducer } from "react-localize-redux";
import locationReducer from "./location";
import commonReducer from "./common";
import categoryReducer from "./category";
import productReducer from "./product";
import cartReducer from "./cart";
import orderReducer from "./order";
import customerReducer from "./customer";

export const makeRootReducer = asyncReducers => {
  return combineReducers({
    location: locationReducer,
    common: commonReducer,
    category: categoryReducer,
    product: productReducer,
    cart: cartReducer,
    order: orderReducer,
    locale: localeReducer,
    customer: customerReducer,
    ...asyncReducers
  });
};

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers.js